// extracted by mini-css-extract-plugin
export default {"not_found_page":"not_found_page___B689F","support":"support___wvUF9"};